angular.module("digitalLeasing.module").component("productDetail", {
  templateUrl: "ng/components/digitalLeasing/leasingHypothesis/productDetail/productDetail.view.html",
  bindings: {
    model: "=",
    onProductChanges: "&?",
    plafond: "<",
    vendor: "<",
    customer: "<",
    productIsOk: "&",
    productIsNotOk: "&",
    exportBaseValidation: "&",
    snapshot: "<",
    financialModel: '<'
  },
  controllerAs: "ProductDetailCtrl",
  controller: ProductDetailController,
});

function ProductDetailController(
  $financialApiService,
  $financialService,
  $q,
  Prodotto,
  FinancialCustomer,
  LeasingData,
  FinancialVendor,
  Listino,
  Convenzione,
  Agevolazione,
  MarcaVeicolo,
  ConvenzionePlafond,
  $scope,
  $rootScope,
  $timeout,
  $configService,
  Motorizzazione
) {
  var self = this;
  self.$rootScope = $rootScope;
  self.isInit = true;
  self.checkInitForSpeseFisse = true;
  var count = 0;
  self.$onInit = function () {
    $rootScope.$broadcast("componentLoader", {
      action: "OPEN"
    });
    self.restCalled = true;
    self.numberOfFacilitationSelected = 2;
    self.numberOfConventionSelected = 1;
    self.supportModel = {
      products: [],
      priceList: [],
      facilitationList: [],
      codAgvObbligatorie: [],
      conventionList: [],
      codCnvObbligatorie: [],
      convention: {},
      plafond: [],
      plafondSelected: "",
    };
    getProducts(self.vendor).then(function (listProduct) {
      self.supportModel.products = listProduct;
      self.enableAccordion = true;
      $rootScope.$broadcast("componentLoader", {
        action: "CLOSE"
      });
    });
    if (self.model.preventivo.prodotto.id) {
      self.model.product = self.model.preventivo.prodotto;
      self.handleProductChange(
        "product",
        self.model.preventivo.prodotto,
        false,
        false,
        true
      );
      self.model.convention = self.model.preventivo.convenzioni[0];
      self.handleProductChange(
        "agevolazioni",
        self.model.preventivo.agevolazioni
      );
      if (self.model.preventivo.convenzionePlafond.cdConvenzione) {
        self.disabledConvention = true;
      }
    }
    if (self.model.preventivo.convenzionePlafond.cdConvenzione) {
      self.supportModel.plafondSelected =
        self.model.preventivo.convenzionePlafond;
    }
    if (self.snapshot) {
      $rootScope.$broadcast("componentLoader", {
        action: "CLOSE"
      });
      $timeout(function () {
        if (self.model.preventivo.agevolazioni.length >= 0) {
          self.agevolazioniSelezionate = self.model.preventivo.agevolazioni;
          self.supportModel.facilitationList = self.model.preventivo.agevolazioni;

        }
      }, 2000)
    }
    $timeout(function () {
      jQuery(".ui.label").addClass('transition visible');
    }, 2000);

    self.disabledPlafond = !!self.model.preventivo.convenzioni.length;
  };

  self.$onChanges = function (changes) {
    if (self.plafond && self.plafond.idPlafond) {
      self.supportModel.products = self.plafond.products;
    }

    if (self.snapshot) {
      if (self.model.preventivo.convenzioni[0]) {
        self.model.convention = self.model.preventivo.convenzioni[0];
      }

      if (self.model.preventivo.agevolazioni.length >= 0) {
        self.agevolazioniSelezionate = self.model.preventivo.agevolazioni;
        self.supportModel = {
          facilitationList: self.model.preventivo.agevolazioni,
        };
      }
    }
  };

  self.handleProductChange = function (
    property,
    value,
    isCalled,
    addConventioAfterRest,
    doNotTouchAgvCnv
  ) {
    if (property != "product") {
      self.model[property] = value;
    }
    console.log("product: ", self.model);

    switch (property) {
      case "amount":
        var controlloMinimo;
        var controlloMassimo;
        self.model.preventivo.importo = value;
        if (self.validation && self.validation.importo && self.validation.importo.minimoBloccante && self.validation.importo.minimoBloccante.valore) {
          controlloMinimo = self.validation.importo.minimoBloccante.valore > self.validation.importo.minimo.valore ? self.validation.importo.minimoBloccante.valore : self.validation.importo.minimo.valore
        } else if (self.validation && self.validation.importo && self.validation.importo.minimo.valore) {
          controlloMinimo = self.validation.importo.minimo.valore;
        }
        if (self.validation && self.validation.importo && self.validation.importo.massimoBloccante && self.validation.importo.massimoBloccante.valore) {
          controlloMassimo = self.validation.importo.massimoBloccante.valore < self.validation.importo.massimo.valore ? self.validation.importo.massimoBloccante.valore : self.validation.importo.massimo.valore
        } else if (self.validation && self.validation.importo && self.validation.importo.massimo.valore) {
          controlloMassimo = self.validation.importo.massimo.valore;
        }
        if (self.validation &&
          (self.model.preventivo.importo <
            controlloMinimo ||
            self.model.preventivo.importo > controlloMassimo)
        ) {
          self.importoMinimo = controlloMinimo;
          self.importoMassimo = controlloMassimo;
          $scope.formProductDetail["productDetail_amount"].$setValidity(
            "productDetail_amount",
            false
          );
          jQuery("#productDetail_amount").addClass("has-error");
          self.enabledErrorImport = true;
        } else {
          $scope.formProductDetail["productDetail_amount"].$setValidity(
            "productDetail_amount",
            true
          );
          jQuery("#productDetail_amount").removeClass("has-error");
          self.enabledErrorImport = false;
        }

        self.onProductChanges({
          product: self.model,
          enableOtherAccordion: true,
          marcaMandatory: self.model.preventivo.prodotto && self.model.preventivo.prodotto.marcaMandatory
        });
        self.checkProductDetailIsOk();
        break;

      case "product":
        if (!doNotTouchAgvCnv) {
          self.agevolazioniSelezionate = [];
          self.model.preventivo.convenzioni = [];
          self.model.preventivo.convenzionePlafond = ConvenzionePlafond.build();
          self.supportModel.plafondSelected = null;
          self.disabledPlafond = false;
          self.model.convention = null;
          jQuery(".agevolazione").dropdown("clear");
        }

        $rootScope.$broadcast("componentLoader", {
          action: "OPEN"
        });

        if (!self.checkInitForSpeseFisse) {
          self.model.preventivo.pianoFinanziario.speseFisse = false;
        } else {
          self.checkInitForSpeseFisse = false;
        }

        self.hideMultiSelect = false;
        if (self.model.product && self.model.product.id && value && value.id != self.model.product.id) {
          self.model.preventivo.prodotto = Prodotto.build(value);
          self.model.preventivo.prodotto.bene.motorizzazione = Motorizzazione.build();
        }
        self.model.product = Prodotto.build(value);
        if (isCalled) {
          self.model.preventivo.listino.ndgListino = null;
          self.model.preventivo.assicurazioni = [];
        }
        productConfigurations(
          FinancialVendor.build(self.vendor),
          FinancialCustomer.build(self.customer),
          LeasingData.build(self.model)

        )
          .then(function (response) {
            self.model.preventivo.listini = response.listini;
            self.supportModel.priceList = response.listini;
            self.supportModel.facilitationList = response.agevolazioni;
            self.supportModel.conventionList = response.convenzioni;
            self.supportModel.plafond = response.plafond;
            self.model.supplier = response.modPagamento;
            self.model.product.isTargato = response.targato;
            self.model.product.marcaMandatory = response.marcaMandatory;

            if (self.model.preventivo.convenzioni.length) {
              var temp = [];
              self.model.preventivo.convenzioni.forEach(function (selected) {
                response.convenzioni.forEach(function (returned) {
                  if (selected.cdConvenzione == returned.cdConvenzione) {
                    temp.push(returned);
                  }
                })
              })
              self.model.preventivo.convenzioni = temp;
            }

            if (self.model.preventivo.agevolazioni.length) {
              var temp = [];
              self.model.preventivo.agevolazioni.forEach(function (selected) {
                response.agevolazioni.forEach(function (returned) {
                  if (selected.id == returned.id) {
                    temp.push(returned);
                  }
                })
              })
              self.model.preventivo.agevolazioni = temp;

            }

            if (self.model.preventivo.convenzionePlafond) {
              self.model.preventivo.convenzionePlafond = response.plafond.find(function (element) {
                return element.cdConvenzione == self.model.preventivo.convenzionePlafond.cdConvenzione;
              })
            }



            if (self.model.preventivo.listino.ndgListino) {
              var defaultListino = response.listini.find(function (e) {
                return e.ndgListino == self.model.preventivo.listino.ndgListino;
              });
              if (!defaultListino) {
                var temp =
                  response.listini &&
                  response.listini.find(function (e) {
                    return e.defaultListino == true;
                  });
                defaultListino = temp ? temp : response.listini[0]
              }
              self.handleProductChange("listino", defaultListino);
            } else {
              var defaultListino =
                response.listini &&
                response.listini.find(function (e) {
                  return e.defaultListino == true;
                });
              if ($configService.getUser().reteVendita == 2) {
                self.handleProductChange(
                  "listino",
                  defaultListino ? defaultListino : response.listini[0]
                );
              } else if (defaultListino && $configService.getUser().reteVendita != 2) {
                self.handleProductChange("listino", defaultListino);

              }
            }


            if (!response.targato) {
              self.model.product.bene.marcaVeicolo = MarcaVeicolo.build();
              self.model.product.bene.stato == "LBL_GOOD_STATE_NEW";
              self.model.quotaEsente = null;
            }
            self.model.preventivo.prodotto = self.model.product;
            self.onProductChanges({
              product: self.model,
              enableOtherAccordion: true,
              marcaMandatory: response.marcaMandatory
            });
            self.hideMultiSelect = true;
            $rootScope.$broadcast("componentLoader", {
              action: "CLOSE"
            });
            $timeout(function () {
              jQuery(".ui.label").addClass('transition visible');
            }, 2000);
          })
          .catch(function (error) {
            console.log("Rest error");
            $rootScope.$broadcast("componentLoader", {
              action: "CLOSE"
            });
          });
        self.checkProductDetailIsOk();
        break;

      case "quotaEsente":
        if (
          parseInt(value) < 0 ||
          parseInt(value) > parseInt(self.model.preventivo.importo)
        ) {
          self.errorQuotaEsente = true;
          $scope.formProductDetail["quotaEsente"].$setValidity(
            "quotaEsente",
            false
          );
          jQuery("#quotaEsente").addClass("has-error");
        } else {
          self.errorQuotaEsente = false;
          $scope.formProductDetail["quotaEsente"].$setValidity(
            "quotaEsente",
            true
          );
          jQuery("#quotaEsente").removeClass("has-error");
        }
        self.checkProductDetailIsOk();
        break;
      case "agevolazioni":
        self.agevolazioniSelezionate = value;
        self.model.preventivo.agevolazioni = [];
        var agevolazioni = [];
        self.supportModel.facilitationList.forEach(function (l) {
          l.selected = false;
        });
        if (self.supportModel.agevolazioni) {
          value.forEach(function (e, index) {
            value[index] = self.supportModel.agevolazioni.find(function (x) {
              return x.id == value[index].id;
            });
          });
        }
        value.forEach(function (e) {
          e.selected = true;
          agevolazioni.push(Agevolazione.build(e));
          self.supportModel.facilitationList.forEach(function (l) {
            if (l.description == e.description && l.id == e.id) {
              l.selected = true;
            }
          });
        });
        self.model.preventivo.agevolazioni = agevolazioni;

        self.checkProductDetailIsOk();
        if (value.length <= 0 && self.restCalled) {
          self.updateAgvCnvList(
            self.model.preventivo.agevolazioni,
            self.model.preventivo.convenzioni,
            true,
            true
          );
          return;
        }
        if (!addConventioAfterRest && self.restCalled) {
          self.updateAgvCnvList(
            self.model.preventivo.agevolazioni,
            self.model.preventivo.convenzioni,
            true
          );
        }
        var listino = self.supportModel.priceList.find(function (e) {
          return e.ndgListino == self.model.preventivo.listino.ndgListino;
        });
        getBaseValidations(
          self.model.product.id,
          listino,
          self.model.preventivo.convenzioni,
          self.model.preventivo.convenzionePlafond,
          self.financialModel.leasingData.isTariffaPlafond,
          self.model.preventivo.agevolazioni
        );

        checkConvFromAgev();
        break;

      case "convention":
        if (!value) {
          self.disabledPlafond = false;
        } else {
          self.disabledPlafond = true;
        }

        if (
          value &&
          self.model.preventivo.convenzioni[0] &&
          value.cdConvenzione ==
          self.model.preventivo.convenzioni[0].cdConvenzione
        ) {
          return;
        }

        if (
          value &&
          self.model.preventivo.convenzioni[0] &&
          value.cdConvenzione !=
          self.model.preventivo.convenzioni[0].cdConvenzione
        ) {
          self.agevolazioniSelezionate = [];
          self.model.preventivo.agevolazioni = [];
        }
        self.model.preventivo.convenzioni = [];
        value =
          value &&
          self.supportModel.conventionList.find(function (e) {
            return e.cdConvenzione == value.cdConvenzione;
          });
        if (value) {
          value.selected = true;
        }
        self.model.preventivo.convenzioni.push(Convenzione.build(value));
        var listino = self.supportModel.priceList.find(function (e) {
          return e.ndgListino == self.model.preventivo.listino.ndgListino;
        });
        if (
          self.model.preventivo.convenzionePlafond &&
          self.model.preventivo.convenzionePlafond.cdConvenzione == null
        ) {
          self.model.preventivo.convenzionePlafond = null;
        }
        if (!value) {
          self.model.preventivo.convenzioni = [];
        }

        getBaseValidations(
          self.model.product.id,
          listino,
          self.model.preventivo.convenzioni,
          self.model.preventivo.convenzionePlafond,
          self.financialModel.leasingData.isTariffaPlafond,
          self.model.preventivo.agevolazioni
        );

        if (!addConventioAfterRest && self.restCalled) {
          self.updateAgvCnvList(
            self.model.preventivo.agevolazioni,
            self.model.preventivo.convenzioni,
            false
          );
        }

        self.checkProductDetailIsOk();
        checkConvFromAgev();
        break;

      case "listino":
        value.ndgAggiornamento = $configService.getUser().ndg;
        self.model.preventivo.listino = Listino.build(value);
        if (
          self.model.preventivo.convenzionePlafond &&
          self.model.preventivo.convenzionePlafond.cdConvenzione == null
        ) {
          self.model.preventivo.convenzionePlafond = null;
        }
        getBaseValidations(
          self.model.product.id,
          value,
          self.model.preventivo.convenzioni,
          self.model.preventivo.convenzionePlafond,
          self.financialModel.leasingData.isTariffaPlafond,
          self.model.preventivo.agevolazioni
        );
        self.checkProductDetailIsOk();
        break;

      case "plafond":
        self.model.preventivo.convenzionePlafond = ConvenzionePlafond.build(
          value
        );
        var listino = self.supportModel.priceList.find(function (e) {
          return e.ndgListino == self.model.preventivo.listino.ndgListino;
        });
        if (self.model.preventivo.convenzionePlafond.cdConvenzione == null) {
          self.model.preventivo.convenzionePlafond = null;
        }
        getBaseValidations(
          self.model.product.id,
          listino,
          self.model.preventivo.convenzioni,
          self.model.preventivo.convenzionePlafond,
          self.financialModel.leasingData.isTariffaPlafond,
          self.model.preventivo.agevolazioni
        );
        if (value) {
          self.disabledConvention = true;
        } else {
          self.disabledConvention = false;
        }
        console.log(value);
        self.checkProductDetailIsOk();
        break;

      case "importoTerreno":
        if (
          parseInt(value.value) < 0 ||
          parseInt(value.value) > parseInt(self.model.preventivo.importo)
        ) {
          self.errorImportoTerreno = true;
          $scope.formProductDetail["importoTerreno"].$setValidity(
            "importoTerreno",
            false
          );
          jQuery("#importoTerreno").addClass("has-error");
        } else {
          self.errorImportoTerreno = false;
          $scope.formProductDetail["importoTerreno"].$setValidity(
            "importoTerreno",
            true
          );
          jQuery("#importoTerreno").removeClass("has-error");
        }
        self.checkProductDetailIsOk();
        break;
      default:
        break;
    }
  };

  var productConfigurations = function (
    financialVendor,
    financialCustomer,
    leasingData
  ) {
    self.disabledAllitem = true;
    var x = financialVendor;
    return $q(function (resolve, reject) {
      if (self.snapshot) {
        return;
      }
      $financialApiService
        .productConfigurations(financialVendor, financialCustomer, leasingData)
        .then(function (list) {
          self.disabledAllitem = false;
          $('#listino :input').prop("disabled", false);
          resolve(list);
        })
        .catch(function (error) {
          self.disabledAllitem = false;
          $('#listino :input').prop("disabled", false);
          reject(error);
        });
    });
  };

  self.updateAgvCnvList = function (
    agevolazioni,
    convenzioni,
    agvMaster,
    notAssignValue
  ) {
    if (self.isInit) {
      return;
    }
    self.disabledOtherInput = true;
    if (self.snapshot) {
      return;
    }
    var agevolazioniTemp = agevolazioni;
    self.restCalled = false;
    var abiVenditore = self.vendor.filiale && self.vendor.filiale.abi;
    $financialService
      .updateAgvCnvList(
        agevolazioni,
        convenzioni,
        self.model.preventivo.prodotto.id,
        self.vendor.reteVendita,
        self.customer.metadata.riUserG,
        agvMaster,
        self.vendor.riUserG.ndg,
        abiVenditore
      )
      .then(function (response) {
        self.restCalled = true;
        self.isExecuted = false;
        self.disabledOtherInput = false;
        if (!response.success) {
          return;
        }
        self.supportModel.agevolazioni = JSON.parse(
          JSON.stringify(response.agevolazioni)
        );
        self.supportModel.convenzioni = JSON.parse(
          JSON.stringify(response.convenzioni)
        );

        response.agevolazioni &&
          response.agevolazioni.forEach(function (e) {
            delete e.codCnvObbligatorie;
            delete e.codCnvEscluse;
          });
        self.supportModel.facilitationList.forEach(function (e) {
          delete e.codCnvObbligatorie;
          delete e.codCnvEscluse;
          delete e.$$hashKey;
        });
        self.supportModel.conventionList.forEach(function (e) {
          delete e.$$hashKey;
          delete e.validations;
        });
        response.convenzioni &&
          response.convenzioni.forEach(function (e) {
            delete e.$$hashKey;
            delete e.validations;
          });
        if (notAssignValue) {
          self.supportModel.conventionList = self.supportModel.convenzioni;
          $timeout(function () {
            self.restCalled = true;
            $(".ui.label").addClass('transition visible');
          }, 2000);
          return;
        }
        self.agevolazioniSelezionate.forEach(function (element) {
          response.agevolazioni.forEach(function (response) {
            if (element.id == response.id) {
              response.selected = true;
            }
          })
        })
        if (
          !response.agevolazioni.equalsArrayObject(
            self.supportModel.facilitationList
          )
        ) {
          self.supportModel.facilitationList = self.supportModel.agevolazioni;
        }

        if (
          !response.convenzioni.equalsArrayObject(
            self.supportModel.conventionList
          )
        ) {
          self.supportModel.conventionList = self.supportModel.convenzioni;
        }

        var convenzioneSelected = response.convenzioni.find(function (e) {
          return e.selected == true;
        });

        if (convenzioneSelected && !self.model.preventivo.convenzionePlafond) {
          self.handleProductChange(
            "convention",
            convenzioneSelected,
            false,
            true
          );
        }

        var agevolazioneSelected = response.agevolazioni.filter(function (e) {
          if (convenzioneSelected) {
            return convenzioneSelected.codAgvObbligatorie[0] == e.id;
          }
        });

        /* if (agevolazioneSelected && agevolazioneSelected[0]) {
          self.handleProductChange(
            "agevolazioni",
            agevolazioneSelected,
            false,
            true
          ); 
        } */
        $timeout(function () {
          self.restCalled = true;
          $(".ui.label").addClass('transition visible');
        }, 2000);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  var getBaseValidations = function (
    codiceProdotto,
    listino,
    convenzioni,
    convenzionePlafond,
    isTariffaPlafond,
    agevolazioni
  ) {
    if (self.snapshot) {
      return;
    }
    $rootScope.$broadcast("componentLoader", {
      action: "OPEN"
    });
    $financialApiService
      .getBaseValidations(
        codiceProdotto,
        listino,
        convenzioni,
        convenzionePlafond,
        isTariffaPlafond,
        null,
        null,
        agevolazioni
      )
      .then(function (response) {
        self.validation = response.result;
        self.exportBaseValidation({
          validation: response,
        });
        self.model.preventivo.validations = response.result;
        if (self.model.preventivo.importo) {
          if (
            self.model.preventivo.importo <
            self.validation.importo.minimo.valore ||
            self.model.preventivo.importo >
            self.validation.importo.massimo.valore
          ) {
            self.importoMinimo = self.validation.importo.minimo.valore;
            self.importoMassimo = self.validation.importo.massimo.valore;
            $scope.formProductDetail["productDetail_amount"].$setValidity(
              "productDetail_amount",
              false
            );
            jQuery("#productDetail_amount").addClass("has-error");
            self.enabledErrorImport = true;
          } else {
            $scope.formProductDetail["productDetail_amount"].$setValidity(
              "productDetail_amount",
              true
            );
            jQuery("#productDetail_amount").removeClass("has-error");
            self.enabledErrorImport = false;
          }
        }
        $timeout(function () {
          self.isInit = false;
        }, 2000);
        $rootScope.$broadcast("componentLoader", {
          action: "CLOSE"
        });
      })
      .catch(function (error) {
        console.log(error);
        $rootScope.$broadcast("componentLoader", {
          action: "CLOSE"
        });
      });
  };

  var checkConvFromAgev = function () {
    var ritorno = false;
    var convObbl = [];
    var convEscl = [];
    var agvObbl = [];
    var agvEscl = [];
    if (self.model.preventivo.agevolazioni.length > 2) {
      self.model.preventivo.agevolazioni.pop();
    }
    self.model.preventivo.agevolazioni.forEach(function (element) {
      convObbl = convObbl.concat(element.codCnvObbligatorie);
      convEscl = convEscl.concat(element.codCnvEscluse);
    });
    self.model.preventivo.convenzioni.forEach(function (element) {
      agvObbl = agvObbl.concat(element.codAgvObbligatorie);
      agvEscl = agvEscl.concat(element.codAgvEscluse);
    });

    self.listOfAgevolazioni = ": ";
    agvObbl.forEach(function (e, idx, array) {
      if (idx === array.length - 1) {
        self.listOfAgevolazioni += e;
      } else {
        self.listOfAgevolazioni += e + ", ";
      }
    });

    self.listOfConvenzioni = " ";
    convObbl.forEach(function (e, idx, array) {
      if (self.listOfConvenzioni.indexOf(e) < 0) {
        if (idx === array.length - 1) {
          self.listOfConvenzioni += e;
        } else {
          self.listOfConvenzioni += e + ", ";
        }
      }
    });

    var convObbSelezionata = self.model.preventivo.convenzioni[0] && convObbl.some(function (e) {
      return e == self.model.preventivo.convenzioni[0].cdConvenzione;
    });

    if (
      (self.model.preventivo.convenzioni.length == 0 && convObbl.length == 0) ||
      (agvEscl.length > 0 && self.model.preventivo.agevolazioni.length == 0)
    ) {
      self.alertConvenzioni = false;
      self.alertAgevolazioni = false;
      ritorno = true;
    } else if (
      (convObbl.length > 0 && self.model.preventivo.convenzioni.length == 0) ||
      (agvObbl.length > 0 && self.model.preventivo.agevolazioni.length == 0) ||
      (convObbl.length > 0 && !convObbSelezionata)
    ) {
      if (
        agvObbl.length > 0 &&
        self.model.preventivo.agevolazioni.length == 0
      ) {
        self.alertAgevolazioni = true;
        ritorno = false;
      } else {
        var checkIfCanGoAlone = self.model.preventivo.agevolazioni
          .some(function (element) {
            return element.canGoAlone == true
          })
        if (checkIfCanGoAlone && self.model.preventivo.convenzioni.length == 0) {

          ritorno = true;
        } else {
          ritorno = false;
          self.alertConvenzioni = true;
        }

      }

    } else if (convObbl.length == 0 && agvObbl.length == 0) {
      self.alertConvenzioni = false;
      self.alertAgevolazioni = false;
      return true;
    } else {
      self.convObbSelected = convObbl.some(function (e) {
        return e == self.model.preventivo.convenzioni[0].cdConvenzione;
      });

      self.convEsclSelected = convEscl.some(function (e) {
        return e == self.model.preventivo.convenzioni[0].cdConvenzione;
      });
      self.convObbSelected2 = agvObbl.some(function (e) {
        return (
          e == self.model.preventivo.agevolazioni[0].id ||
          (self.model.preventivo.agevolazioni[1] &&
            e == self.model.preventivo.agevolazioni[1].id)
        );
      });

      self.convEsclSelected2 = agvEscl.some(function (e) {
        return e == self.model.preventivo.agevolazioni[0].id;
      });
      if (convObbl.length == 0) {
        self.convObbSelected = true;
      }

      if (agvObbl.length == 0) {
        self.convObbSelected2 = true;
      }
      self.alertAgevolazioni = false;
      ritorno =
        self.convObbSelected &&
        !self.convEsclSelected &&
        self.convObbSelected2 &&
        !self.convEsclSelected2;
    }
    if (agvObbl.length > 0) {
      agvObbl.forEach(function (e) {
        self.alertAgevolazioni = !self.model.preventivo.agevolazioni.some(
          function (f) {
            return e == f.id;
          }
        );
      });
    }

    if (ritorno) {
      self.alertConvenzioni = false;
    }

    return ritorno;
  };

  self.checkProductDetailIsOk = function () {
    var test =
      (checkConvFromAgev() || self.disabledConvention && self.alertConvenzioni) &&
      $scope.formProductDetail &&
      $scope.formProductDetail.$valid &&
      self.model.preventivo.listino.ndgListino;

    if (test) {
      self.productIsOk();
    } else {
      self.productIsNotOk();
    }
  };

  var getProducts = function (vendor) {
    return $q(function (resolve, reject) {
      if (self.snapshot) {
        return;
      }
      Object.assign(vendor, {
        legalFormCli: self.financialModel.financialCustomer.metadata.riUserG.formaGiuridica
      });
      $financialApiService
        .getMyProduct(vendor)
        .then(function (list) {
          resolve(list);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  };

  self.showHideListini = function () {
    self.model.showAllListini = !self.model.showAllListini;
    getListini();
  }

  var getListini = function () {
    $rootScope.$broadcast("componentLoader", {
      action: "OPEN"
    });
    $financialApiService.getListini(self.financialModel)
      .then(function (response) {
        self.supportModel.priceList = response.listini;
        var listinoDefault = response.listini
          .find(function (element) {
            return element.defaultListino == true;
          })
        self.handleProductChange("listino", listinoDefault);
        self.model.preventivo.listini = response.listini;
        $rootScope.$broadcast("componentLoader", {
          action: "CLOSE"
        });
      })
      .catch(function (error) {
        console.log(error);
        $rootScope.$broadcast("componentLoader", {
          action: "CLOSE"
        });
      })
  }
}